/**
 *
 */
(function (window, document, undefined) {
  'use strict';
  var Run = function (
    $http,
    $q,
    $stateParams,
    userSrvc,
    messaggiFctr,
    labelSrvc,
    loggerSrvc,
    CONSTANTS,
    ssocoreServices,
    brioSrvc
  ) {
    var userSrvcDefer = $q.defer();
    var labelSrvcDefer = $q.defer();
    userSrvc.abilitazioniPronte = userSrvcDefer.promise;
    labelSrvc.labelsPronte = labelSrvcDefer.promise;

    var startService = function () {
      ssocoreServices.caricaContesto(
        function (response) {
          //			Se l'inserimento degli ordini è abilitato
          if (
            ssocoreServices.caricaFunzionalita(
              response,
              'InserimentoOrdiniVisibile'
            )
          ) {
            userSrvc.inserimentoOrdiniVisibile = true;
          }
          //			Setting delle variabili in base ai Parametri di Installazione
          if (
            ssocoreServices.caricaFunzionalita(
              response,
              'ConsulenzaFinanzaVisibile'
            )
          ) {
            startAbilitazioniPromise();
            startLabelsPromise();
            startLoggerPromise();

            if (response.app.codice === 'scrivaniautente') {
              brioSrvc.brioVersion = 'brio-xc';
            }

            response.parametriInstallazione.forEach(function (parametro) {
              //					Parametro SSO per il numero massimo di proposte acquistabili
              if (
                parametro.codice.toUpperCase() === 'CONSULENZANUMEROPROPOSTE'
              ) {
                userSrvc.numeroProposteAcquistabili = Number(parametro.valore);
              }
              //					Parametro SSO per mostrare/nascondere pulsante abilita consulenza
              if (
                parametro.codice.toUpperCase() === 'NASCONDIABILITACONSULENZA'
              ) {
                userSrvc.nascondiAbilitaConsulenza =
                  parametro.valore === 'true' ? true : false;
              }
              //					Parametro SSO per permettere al promotore di accettare le raccomandazioni
              if (
                parametro.codice.toUpperCase() ===
                'PROMOTOREACCETTARACCOMANDAZIONE'
              ) {
                userSrvc.promotoreAccettaRaccomandazione = parametro.valore;
              }
              //					Parametro SSO per forzare la scelta delle intestazioni in una proposta di tipo fondo
              if (
                parametro.codice.toUpperCase() === 'SELEZIONEINTESTCOIFONDO'
              ) {
                userSrvc.selezioneIntestCoiFondo = parametro.valore;
              }
              //					Parametro SSO per presettare l'iniziativa senza far apparire la modale
              if (
                parametro.codice.toUpperCase() === 'INIZIATIVARACCOMANDAZIONE'
              ) {
                userSrvc.iniziativaRaccomandazione = parametro.valore;
              }
              //					Parametro SSO per sapere se far apparire l'informativa nello step upload della raccomandazione
              if (parametro.codice.toUpperCase() === 'INFOUPLOADDOCUMENTI') {
                userSrvc.infoUploadDocumenti = parametro.valore.toLowerCase();
              }
              //					Parametro SSO per limitare alla sola vendita l'inserimento degli ordini
              if (
                parametro.codice.toUpperCase() === 'MOSTRASOLOVENDITAORDINI'
              ) {
                userSrvc.mostraSoloVenditaOrdini =
                  parametro.valore === 'true' ? true : false;
              }
            });

            if (userSrvc.isBpa && !userSrvc.iniziativaRaccomandazione) {
              userSrvc.iniziativaRaccomandazione = 'B';
            }
          }
          //			Se sono in brio flexcube controllo il canale operativo
          if (brioSrvc.brioVersion === 'brio-xc') {
            //				Se c'è un parametro con valore FILIALE allora setto filialefxc
            if (
              response.parametri.some(function (parametro) {
                return parametro.valore === 'FILIALE';
              })
            ) {
              userSrvc.canaleOperativo = 'filialefxc';
            } else {
              //					Altrimenti lo setto come briofxc
              userSrvc.canaleOperativo = 'briofxc';
            }
          }
        },
        function (reason) {}
      );
    };

    var parametriDaAbilitazione = [
      CONSTANTS.ABILITAZIONI.VISUALIZZA_PARAMETRI_BLOCCATI,
      CONSTANTS.ABILITAZIONI.FILTRA_RACCOMANDAZIONI,
      CONSTANTS.ABILITAZIONI.COPIA_RACCOMANDAZIONE,
      CONSTANTS.ABILITAZIONI.TABELLA_RACCOMNDAZIONI_ESTESA,
      CONSTANTS.ABILITAZIONI.VERIFICA_PROPOSTE,
      CONSTANTS.ABILITAZIONI.CASHFLOW,
      CONSTANTS.ABILITAZIONI.ESG_CONSULENZA_ATTIVA,
      CONSTANTS.ABILITAZIONI.ATTIVA_LIQUIDITA_AGGIUNTIVA,
      CONSTANTS.ABILITAZIONI.RICONTRATTUALIZZAZIONE
    ];

    /**
     * Carica le abilitazioni dell'utente loggato
     */
    var startAbilitazioniPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.USER,
        params: { ndg: $stateParams.ndg }
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            userSrvcDefer.reject(response);
            return;
          }
          userSrvc.user = response.data.result.profile;
          userSrvc.abilitazioni = response.data.result.abilitazioni;
          if (!!response.data.result.parametri) {
            response.data.result.parametri.forEach(function (parametro) {
              if (
                (parametriDaAbilitazione.indexOf(parametro.codice) > -1 &&
                  parametro.valore === 'Y') ||
                (parametro.codice === CONSTANTS.ABILITAZIONI.MIFID &&
                  (parametro.valore === 'S' || parametro.valore === 'T'))
              ) {
                userSrvc.abilitazioni.push({
                  codice: parametro.codice,
                  descrizione: parametro.codice
                });
              }
            });
          }
          if (!!response.data.result.parametriInstallazione) {
            response.data.result.parametriInstallazione.forEach(function (
              parametro
            ) {
              if (
                (parametriDaAbilitazione.indexOf(parametro.codice) > -1 &&
                  (parametro.valore === 'Y' || parametro.valore === 'true')) ||
                (parametro.codice === CONSTANTS.ABILITAZIONI.MIFID &&
                  (parametro.valore === 'S' || parametro.valore === 'T'))
              ) {
                userSrvc.abilitazioni.push({
                  codice: parametro.codice,
                  descrizione: parametro.codice
                });
              } else {
                userSrvc.configurazioni[parametro.codice] = parametro.valore;
              }
            });
            userSrvc.modalitaEsposizioneESG =
              userSrvc.configurazioni[
                CONSTANTS.ABILITAZIONI.MODALITA_ESPOSIZIONE_ESG_STRUMENTO
              ];
          }

          userSrvc.doppiaPrecisioneQuantita =
            response.data.result.profile.banca === '03138';

          userSrvc.valutaPratica = response.data.result.abilitazioni.some(
            function (abilitazione) {
              return (
                abilitazione.codice.toLowerCase() ===
                CONSTANTS.ABILITAZIONI.VALUTA_PRATICA.toLowerCase()
              );
            }
          );
          userSrvc.liquiditaAggiuntivaAttiva =
            response.data.result.abilitazioni.some(function (abilitazione) {
              return (
                abilitazione.codice.toLowerCase() ===
                CONSTANTS.ABILITAZIONI.ATTIVA_LIQUIDITA_AGGIUNTIVA.toLowerCase()
              );
            });
          userSrvcDefer.resolve(true);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
          userSrvcDefer.reject(reason);
        }
      );
    };

    /**
     * Carica le labels dell'applicazione
     */
    var startLabelsPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LABEL
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            labelSrvcDefer.reject(response);
            return;
          }
          labelSrvc.labels = response.data.result;
          labelSrvcDefer.resolve(true);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
          labelSrvcDefer.reject(reason);
        }
      );
    };

    /**
     * Imposta il livello di logger per i messaggi da loggare
     */
    var startLoggerPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            return;
          }
          loggerSrvc.setupLogger(response.data.result);
          labelSrvc.develop = loggerSrvc.levelEnabled(loggerSrvc.FINE);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
        }
      );
    };

    this.runned = false;

    this.avvio = function () {
      if (this.runned) {
        return $q.when(true);
      }
      var defer = $q.defer();
      startService();
      self.runned = true;
      $q.all({
        userSrvcDefer: userSrvcDefer,
        labelSrvcDefer: labelSrvcDefer
      }).then(
        function (response) {
          defer.resolve(response);
        },
        function (reason) {
          this.runned = false;
          defer.reject(reason);
        }
      );
      return defer.promise;
    };

    this.runnedLabel = false;
    var self = this;

    this.avvioLabel = function () {
      if (this.runnedLabel || this.runned) {
        return $q.when(true);
      }
      var defer = $q.defer();
      self.runnedLabel = true;
      ssocoreServices.caricaContesto(function (response) {
        if (
          ssocoreServices.caricaFunzionalita(
            response,
            'ConsulenzaFinanzaVisibile'
          )
        ) {
          startService();
          this.runned = true;
        } else {
          startAbilitazioniPromise();
          $http({
            method: 'GET',
            url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LABEL
          }).then(
            function (response) {
              if (messaggiFctr.processaResponse(response)) {
                defer.reject(response);
                return;
              }
              labelSrvc.labels = response.data.result;
              defer.resolve(true);
            },
            function (reason) {
              messaggiFctr.processaResponse(reason);
              defer.reject(reason);
            }
          );
        }
      });

      return defer.promise;
    };
  };

  Run.$inject = [
    '$http',
    '$q',
    '$stateParams',
    'FinUserSrvc',
    'FinMessaggiFctr',
    'FinLabelSrvc',
    'FinLoggerSrvc',
    'FIN_CONSTANTS',
    'ssocoreServices',
    'FinBrioSrvc'
  ];
  angular.module('cbl.finanza.mf').service('FinanzaRunService', Run);
})(window, document);



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.run.js
 ** module id = 30
 ** module chunks = 0 1 2
 **/